
import React from 'react';
import { cn } from '@/lib/utils';
import { TechniquePosition, TechniqueType } from '@/types/technique';

type StatusType = 
  | 'beginner' | 'intermediate' | 'advanced' 
  | 'fundamental' | 'variation' | 'competition'
  | TechniquePosition 
  | TechniqueType
  | string;

interface StatusLabelProps {
  type: StatusType;
  className?: string;
}

export const StatusLabel: React.FC<StatusLabelProps> = ({ type, className }) => {
  const baseClasses = "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium";
  
  const typeClasses: Record<string, string> = {
    // Difficulty levels
    beginner: "bg-bjj-white/10 text-bjj-white border border-bjj-white/20",
    intermediate: "bg-bjj-blue/10 text-bjj-blue border border-bjj-blue/20",
    advanced: "bg-bjj-purple/10 text-bjj-purple border border-bjj-purple/20",
    
    // Technique types
    choke: "bg-red-500/10 text-red-500 border border-red-500/20",
    joint_lock: "bg-amber-500/10 text-amber-500 border border-amber-500/20",
    sweep: "bg-green-500/10 text-green-500 border border-green-500/20",
    takedown: "bg-blue-500/10 text-blue-500 border border-blue-500/20",
    control: "bg-purple-500/10 text-purple-500 border border-purple-500/20",
    escape: "bg-cyan-500/10 text-cyan-500 border border-cyan-500/20",
    defensive: "bg-yellow-500/10 text-yellow-500 border border-yellow-500/20",
    other: "bg-gray-500/10 text-gray-500 border border-gray-500/20",
    
    // Positions
    standing: "bg-indigo-500/10 text-indigo-500 border border-indigo-500/20",
    top: "bg-emerald-500/10 text-emerald-500 border border-emerald-500/20",
    bottom: "bg-amber-500/10 text-amber-500 border border-amber-500/20",
    transitional: "bg-violet-500/10 text-violet-500 border border-violet-500/20",
    
    // Legacy types (keeping for compatibility)
    fundamental: "bg-green-500/10 text-green-500 border border-green-500/20",
    variation: "bg-amber-500/10 text-amber-500 border border-amber-500/20",
    competition: "bg-red-500/10 text-red-500 border border-red-500/20",
  };
  
  return (
    <span className={cn(
      baseClasses, 
      typeClasses[type] || "bg-gray-500/10 text-gray-500 border border-gray-500/20", 
      className
    )}>
      {type.replace('_', ' ').charAt(0).toUpperCase() + type.replace('_', ' ').slice(1)}
    </span>
  );
};
